import { getFileData, getFileMetadata } from "../utility/storage";
import { apiRequest, postPython } from "../api/ApiCall";
import { LOCAL_CONSTANT } from "./Const";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setObjAppHeader } from "../features/appHeaderSlice";
import { getLongPageData } from "../data/DataManage";
import { encryptQueryParam } from "../utility/util";
import dayjs from "dayjs";

// トークン取得
export const getAccessToken = () => {
    let access_token = "?access_token=";
    const objectJSON = sessionStorage.getItem("token");
    if (objectJSON) {
        access_token = "?access_token=" + JSON.parse(objectJSON) + "";
    }

    return access_token;
};

// スタッフ名取得
export const staffName = (code: string) => {
    let name = "";
    const res: any = localStorage.getItem("staffMaster");
    if (res) {
        // const d = JSON.parse(res)
        JSON.parse(res)?.map((row: any) => {
            if (row.staff_number === code) {
                name = row.staff_name;
            }
        });
    }

    return name;
};

export const setSelecterDisplay = (codeMaster: any, code_value: string) => {
    let code_display = "";
    if (codeMaster && code_value !== "" && code_value !== undefined) {
        codeMaster.filter((row: any) => {
            if (row.code_value === code_value.toString()) {
                code_display = row.code_display;
            }
        });
    }
    return code_display;
};

export const setSelecterValue = (codeMaster: any, code_display: string) => {
    let code_value = "";
    if (codeMaster && code_display !== "" && code_display !== undefined) {
        codeMaster.filter((row: any) => {
            if (row.code_display === code_display.toString()) {
                code_value = row.code_value;
            }
        });
    }
    return code_value;
};

/**
 * ダウンロードファイル名指定でファイルダウンロード
 * @param filePath ダウンロードパス
 * @param fileName ファイル名
 */
export const commonFileDownload = (filePath: string, fileName: string) => {
    (async () => {
        try {
            const url = await getFileData(filePath);
            const xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = (event) => {
                const blob = xhr.response;
                const link = document.createElement("a");
                document.body.appendChild(link);
                link.download = fileName;
                link.href = window.URL.createObjectURL(blob);
                link.click();
                document.body.removeChild(link);
            };
            xhr.open("GET", url as string);
            xhr.send();
        } catch (e) {
            console.log(e);
        }
    })();
};

/**
 * アップロードファイル名でファイルダウンロード
 * @param filePath ダウンロードパス
 */
export const commonFileDownloadFileName = (filePath: string) => {
    (async () => {
        try {
            getFileMetadata(filePath).then((metaData: any) => {
                getFileData(filePath).then((url: any) => {
                    const xhr = new XMLHttpRequest();
                    xhr.responseType = "blob";
                    xhr.onload = (event) => {
                        const blob = xhr.response;
                        const link = document.createElement("a");
                        document.body.appendChild(link);
                        link.download = metaData.name;
                        link.href = window.URL.createObjectURL(blob);
                        link.click();
                        document.body.removeChild(link);
                    };
                    xhr.open("GET", url as string);
                    xhr.send();
                });
            });
        } catch (e) {
            console.log(e);
        }
    })();
};

/**
 * 各パラメータに対してのAPIリクエストを実行
 * @param params APIに送るパラメータのリスト
 */
export const updateListRegist = (params: any) => {
    return new Promise((resolve, reject) => {
        params.map((param: any) => {
            (async () => {
                try {
                    await apiRequest(param);
                    resolve(true);
                } catch (e) {
                    console.log(e);
                    reject();
                }
            })();
        });
    });
};

/**
 * ファイル拡張子チェック
 * 
 * 指定されたファイルの拡張子が許可されているかをチェックし、エラーの場合は自動的にエラーモーダルを表示する
 * @param file チェック対象ファイル
 * @param allowedExtensions 許可する拡張子配列（例: [".xlsx", ".pdf"]）
 * @param setMessageDialogOpen モーダル開閉状態を設定する関数
 * @param setMessage エラーメッセージを設定する関数
 * @param setHasButton モーダルのボタン表示状態を設定する関数
 * @param errorMessage 表示するエラーメッセージ
 * @returns チェック結果（true: 拡張子が許可されている, false: 拡張子エラー）
 * 
 * @example
 * // Excelファイルのチェック例
 * const isValid = fileExtensionCheck(
 *   file, 
 *   LOCAL_CONSTANT.FILE_EXTENSIONS.EXCEL, 
 *   setMessageDialogOpen, 
 *   setMessage, 
 *   setHasButton,
 *   LOCAL_CONSTANT.CONFIRM_MESSAGE.EXTENSION_CHECK_EXCEL
 * );
 */
export const fileExtensionCheck = (
    file: File, 
    allowedExtensions: string[],
    setMessageDialogOpen: (open: boolean) => void,
    setMessage: (message: string) => void,
    setHasButton: (hasButton: boolean) => void,
    errorMessage: string
): boolean => {
    // ファイル名から拡張子を取得（小文字に変換）
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    
    // 許可された拡張子リストに含まれているかチェック
    if (!allowedExtensions.includes(fileExtension)) {
        // エラーの場合、モーダルを表示
        setMessageDialogOpen(true);
        setMessage(errorMessage);
        setHasButton(true);
        return false;
    }
    
    // 拡張子が許可されている場合
    return true;
};

//テーブル名の論理名をセット
export const setTableLogicName = (table_physics_name: string, column_physics_name: string) => {
    const tableNameMasterObj = localStorage.getItem("tableNameMaster");
    let table_logic_name = table_physics_name;
    if (tableNameMasterObj) {
        const jsonObj = JSON.parse(tableNameMasterObj);
        let found = false;
        
        // 最初に両方のパラメータで正確な検索を実施
        jsonObj.some((row: any) => {
            if (row.table_physics_name === table_physics_name && 
                row.column_physics_name === column_physics_name) {
                table_logic_name = row.table_logic_name;
                found = true;
                return true; // 条件を満たしたのでループを終了
            } else {
                return false;
            }
        });
        
        // 見つからない場合はtable_physics_nameのみで検索
        if (!found) {
            jsonObj.some((row: any) => {
                if (row.table_physics_name === table_physics_name) {
                    table_logic_name = row.table_logic_name;
                    return true; // 条件を満たしたのでループを終了
                } else {
                    return false;
                }
            });
        }
    }
    return table_logic_name;
};

//テーブル名の物理名をセット
export const setTablePhysicsName = (table_logic_name: string) => {
    const tableNameMasterObj = localStorage.getItem("tableNameMaster");
    let table_physics_name = table_logic_name;
    if (tableNameMasterObj) {
        const jsonObj = JSON.parse(tableNameMasterObj);
        jsonObj.some((row: any) => {
            if (row.table_logic_name === table_logic_name) {
                table_physics_name = row.table_physics_name;
                return true; // 条件を満たしたのでループを終了
            } else {
                return false;
            }
        });
    }
    return table_physics_name;
};

//テーブル項目名の論理名をセット
export const setColumnLogicName = (table_physics_name: string, column_physics_name: string) => {
    const tableNameMasterObj = localStorage.getItem("tableNameMaster");
    let column_logic_name = column_physics_name;
    if (tableNameMasterObj) {
        const jsonObj = JSON.parse(tableNameMasterObj);
        jsonObj.some((row: any) => {
            if (
                row.table_physics_name === table_physics_name &&
                row.column_physics_name === column_physics_name
            ) {
                column_logic_name = row.column_logic_name;
                return true; // 条件を満たしたのでループを終了
            } else {
                return false;
            }
        });
    }
    return column_logic_name;
};

//ページとテーブル名紐づけ
export const pageToTableMapFunc = (pageName: string) => {
    let pageToTableMap = "";
    switch (pageName) {
        // 追加資料ページはテーブル名をlocation_add_surveyに合わせる
        case LOCAL_CONSTANT.NAVI.ADDITIONAL_RESEARCH:
            pageToTableMap = LOCAL_CONSTANT.TABLE.ADDITIONAL_RESEARCH;
            break;
        // その他資料ページはテーブル名をlocation_baseに合わせる
        case LOCAL_CONSTANT.NAVI.OTHER_DOCUMENT:
            pageToTableMap = LOCAL_CONSTANT.TABLE.BASE;
            break;
        // 表紙ページはテーブル名をlocation_coverに合わせる
        case LOCAL_CONSTANT.NAVI.COVER:
            pageToTableMap = LOCAL_CONSTANT.TABLE.COVER;
            break;
        // 競合ページはテーブル名をlocation_conflictに合わせる
        case LOCAL_CONSTANT.NAVI.CONFLICT:
            pageToTableMap = LOCAL_CONSTANT.TABLE.CONFLICT;
            break;
        // 競合ページの商圏カット根拠はテーブル名をlocation_conflict_market_cutに合わせる
        case LOCAL_CONSTANT.NAVI.TRADE_AREA_CUT:
            pageToTableMap = LOCAL_CONSTANT.TABLE.CONFLICT_MARKET_CUT;
            break;
        default:
            pageToTableMap = pageName;
            break;
    }
    return pageToTableMap;
};


// 候補地情報取得
export const getPlanAreaInfo = (planAreaId: string | null, objStorePlanAreaId: string) => {
    let searchPlanAreaId = planAreaId;
    let planAreaInfoJSON = ""
    if (planAreaId !== null) {
        if (planAreaId.startsWith("X") || planAreaId.startsWith("Y")) {
            searchPlanAreaId = objStorePlanAreaId;
        }
    }
    const params = {
        mode: "regist",
        endPoint: "/sfdc/planArea/v1/info",
        query: {
            plan_area_id: searchPlanAreaId,
        },
    };
    return new Promise(resolve => {
        (async () => {
            try {
                const apiPlanAreaInfo = await apiRequest(params);
                if (apiPlanAreaInfo.data.dataList.length > 0) {
                    planAreaInfoJSON = JSON.parse(apiPlanAreaInfo.data.dataList[0]);
                    resolve(planAreaInfoJSON)
                }
            } catch (e) {
                console.log(e);
            }
        })();
    })

};

/**
 * planAreaSearchByIdのAPIパラメータを構築する共通関数
 * ユーザー権限に基づいて適切なパラメータを生成する
 * @param planAreaId 候補地ID
 * @param userData ユーザーデータ（JSON文字列）
 * @param objStorePlanAreaId
 * @returns planAreaSearchByIdのAPIパラメータ
 */
export const createPlanAreaSearchByIdParam = (
    planAreaId: string,
    userData: string,
    objStorePlanAreaId: string = ""
): any => {
    let searchPlanAreaId = planAreaId;
    
    // ユーザーデータをパース
    const jsonUserData = JSON.parse(userData);
    
    // 管理都市フラグの設定（管理者または全都市管理の場合はfalse）
    let manageCitiesFlg = true;
    if (
        jsonUserData.administrator_flag === "1" ||
        jsonUserData.manage_cities?.includes("ALL")
    ) {
        manageCitiesFlg = false;
    }
    
    // 管理ステップの設定
    const manage_steps = ["0", "99"];
    // 複製店舗は既存店のためSTEP8は対象外
    if (
        planAreaId &&
        !planAreaId.startsWith("X") &&
        !planAreaId.startsWith("Y")
    ) {
        manage_steps.push("8");
    }
    
    // ステップカウントの計算
    let stepCnt = jsonUserData.manage_steps.filter(
        (val: any) => manage_steps.includes(val) === false
    );
    
    // 管理都市外プランの設定
    let managePlansOutsideCities = jsonUserData.manage_plans_outside_cities;
    if (!managePlansOutsideCities.includes("")) {
        managePlansOutsideCities.push("");
    }
    
    // 複製店舗の場合は検索対象IDを変更
    if (
        planAreaId &&
        (planAreaId.startsWith("X") || planAreaId.startsWith("Y")) &&
        objStorePlanAreaId
    ) {
        searchPlanAreaId = objStorePlanAreaId;
    }
    
    // APIパラメータを返す
    return {
        mode: "planAreaSearchById",
        id: searchPlanAreaId,
        manageCitiesFlg: manageCitiesFlg,
        manageCities: jsonUserData.manage_cities.join(","),
        manageStep: stepCnt.join(","),
        managePlansOutsideCities: managePlansOutsideCities.join(","),
    };
};

/**
 * ヘッダー表示用のplanAreaSearchById呼び出しカスタムHook
 * 候補地情報を取得してRedux storeに設定する
 * ItemChangeHistoryで使用
 * @returns planAreaId と userData のみを引数とする関数
 */
export const usePlanAreaSearchByIdForHeader = () => {
    const dispatch = useAppDispatch();
    const objAppHeader = useAppSelector((state) => state.appHeader);
    
    return async (planAreaId: string, userData: string): Promise<void> => {
        // 入力値チェック
        if (!userData || planAreaId === "") return;
        
        try {
            // パラメータ作成
            const param = createPlanAreaSearchByIdParam(planAreaId, userData);
            
            // API呼び出し
            const res: any = await getLongPageData([param]);
            
            // レスポンスチェックとRedux更新
            if (res.planAreaSearchById && res.planAreaSearchById.length > 0) {
                dispatch(
                    setObjAppHeader({
                        ...objAppHeader,
                        planAreaId: res.planAreaSearchById[0].id,
                        planAreaName: res.planAreaSearchById[0].plan_area_name,
                        citycode: res.planAreaSearchById[0].citycode,
                        centerlat: res.planAreaSearchById[0].centerlat,
                        centerlon: res.planAreaSearchById[0].centerlon,
                    })
                );
            }
        } catch (e) {
            console.log("planAreaSearchById API呼び出しエラー:", e);
        }
    };
};

/**
 * PDFファイルリストをupload_dateで昇順ソートする共通関数
 * @param fileList ソート対象のファイルリスト
 * @param dateFormat 日付フォーマット（デフォルト: "YYYY/MM/DD HH:mm:ss"）
 * @returns upload_dateで昇順ソートされたファイルリスト
 * 
 * @example
 * // その他資料RR PDFファイルのソート
 * const sortedFiles = sortFilesByUploadDate(otherDocumentRRList);
 * 
 * // カスタム日付フォーマットでのソート
 * const sortedFiles = sortFilesByUploadDate(fileList, "YYYY-MM-DD");
 */
export const sortFilesByUploadDate = (
    fileList: any[],
    dateFormat: string = "YYYY/MM/DD HH:mm:ss"
): any[] => {
    if (!fileList || fileList.length === 0) {
        return fileList;
    }
    
    return fileList.sort((a, b) => {
        // upload_dateが存在しない場合は最後に配置
        if (!a.upload_date && !b.upload_date) return 0;
        if (!a.upload_date) return 1;
        if (!b.upload_date) return -1;
        
        // dayjsを使用して日付を解析・比較
        const dateA = dayjs(a.upload_date, dateFormat);
        const dateB = dayjs(b.upload_date, dateFormat);
        
        // 無効な日付の場合は最後に配置
        if (!dateA.isValid() && !dateB.isValid()) return 0;
        if (!dateA.isValid()) return 1;
        if (!dateB.isValid()) return -1;
        
        // 昇順ソート（古い順）
        return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
    });
};

/**
 * 別タブ遷移処理
 * 指定されたロケーションに応じて新しいタブでページを開く
 * R_VIEWの場合は外部サイト、その他の場合は内部ページに遷移する
 * 
 * @param location 遷移先パス（例: "/RequestComment", "/DeficiencyComment", "/r_view"等）
 * @param planAreaId 候補地ID
 * @param branch 枝番
 * @param utilityCtx スピナー制御用のユーティリティコンテキスト
 * @param objStorePlanAreaId 複製店舗用候補地ID（R_VIEW遷移時にオプションで使用）
 * 
 * @example
 * // 依頼/コメントページを別タブで開く
 * handleNewTabPage("/RequestComment", planAreaId, branch, utilityCtx);
 * 
 * // R_VIEWを別タブで開く
 * handleNewTabPage("/r_view", planAreaId, branch, utilityCtx, objStorePlanAreaId);
 */
export const handleNewTabPage = (
    location: string,
    planAreaId: string | null,
    branch: string | null,
    utilityCtx: any,
    objStorePlanAreaId: string = ""
) => {
    if (utilityCtx.showSpinner) {
        utilityCtx.showSpinner();
    }
    
    let baseUrl = "";
    let newTabUrl = "";
    let param = "";
    
    if (location === "/r_view") {
        let usePlanAreaId = planAreaId;
        if (objStorePlanAreaId !== "") {
            usePlanAreaId = objStorePlanAreaId;
        }
        baseUrl = process.env.REACT_APP_RECRUIT_VIEW!;
        newTabUrl = `${baseUrl}?mode=detail_prop_site&id=${usePlanAreaId}&encryptionFlag=0`;
        window.open(newTabUrl);
        if (utilityCtx.hideSpinner) {
            utilityCtx.hideSpinner();
        }
    } else {
        baseUrl = window.location.origin;
        param = `planAreaId=${planAreaId}&branch=${branch}`;
        // URLクエリパラメータ暗号化
        encryptQueryParam(param).then((res) => {
            newTabUrl = `${baseUrl}${location}?` + res;
            window.open(newTabUrl);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e: any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    }
};

/**
 * 依頼/コメントボタンの表示条件判定
 * RFCユーザーまたは子調査（候補地IDがX/Yで始まる）の場合は非表示にする
 * 
 * @param userType ユーザータイプ（LOCAL_CONSTANT.USER_TYPE.RRやLOCAL_CONSTANT.USER_TYPE.RFC等）
 * @param planAreaId 候補地ID
 * @returns ボタンを表示する場合はtrue、非表示の場合はfalse
 * 
 * @example
 * // 依頼/コメントボタンの表示判定
 * const shouldShow = shouldShowRequestCommentButton(userType, planAreaId);
 * if (shouldShow) {
 *   // ボタンを表示
 * }
 */
export const shouldShowRequestCommentButton = (
    userType: string,
    planAreaId: string | null
): boolean => {
    return (
        userType !== LOCAL_CONSTANT.USER_TYPE.RFC && 
        (planAreaId?.startsWith("X") || planAreaId?.startsWith("Y")) === false
    );
};

/**
 * 枝番の値を比較する関数（1文字専用）- 昇順ソート用
 * ソート順: 0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ（Javaのslistと同じ）
 * @param a 比較対象の枝番1（1文字）
 * @param b 比較対象の枝番2（1文字）
 * @returns a > b なら 1、a < b なら -1、a = b なら 0（昇順ソート用）
 * 
 * @example
 * // 枝番の昇順比較例
 * compareBranchValues("A", "B"); // -1 (A < B)
 * compareBranchValues("1", "A"); // -1 (1 < A)
 * compareBranchValues("Z", "0"); // 1 (Z > 0)
 * compareBranchValues("9", "A"); // -1 (9 < A)
 */
export const compareBranchValues = (a: string, b: string): number => {
    // 枝番のソート順定義（JavaのsetNextBranchのslistと同じ）
    const BRANCH_ORDER = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    
    // 空文字列の処理
    if (!a && !b) return 0;
    if (!a) return -1;
    if (!b) return 1;
    
    // 1文字の位置を取得して比較
    const indexA = BRANCH_ORDER.indexOf(a.toUpperCase());
    const indexB = BRANCH_ORDER.indexOf(b.toUpperCase());
    
    // 無効な文字の処理（ソート順にない文字は最後に配置）
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    
    // インデックスで比較
    return indexA < indexB ? -1 : indexA > indexB ? 1 : 0;
};

/**
 * 全角数字を半角数字に変換する関数
 * 先頭が全角ゼロ「０」の場合は変換しない
 * @param text 変換対象のテキスト
 * @returns 変換後のテキスト
 * 
 * @example
 * // 全角数字の変換例
 * convertZenkakuToHankaku("１２３"); // "123"
 * convertZenkakuToHankaku("０１２"); // "０１２" (先頭が全角ゼロの場合は変換しない)
 * convertZenkakuToHankaku(""); // ""
 * convertZenkakuToHankaku("abc１２３"); // "abc123"
 */
export const convertZenkakuToHankaku = (text: string): string => {
    if (!text) return text;
    if (text.startsWith("０")) return text; // 先頭が全角ゼロの場合は変換しない
    return text.replace(/[０-９]/g, (char) => 
        String.fromCharCode(char.charCodeAt(0) - 0xfee0)
    );
};

/**
 * iPad判定関数
 * iPadデバイスかどうかを判定する
 * @returns iPadの場合はtrue、それ以外はfalse
 * 
 * @example
 * // iPad判定の使用例
 * if (isIpad()) {
 *   // iPad専用の処理
 * } else {
 *   // その他デバイスの処理
 * }
 */
export const isIpad = (): boolean => {
    return /iPad/.test(navigator.userAgent) && "ontouchend" in document;
};
